(function () {
  var root = document.body;
  if (!root || !root.classList.contains('gds-faq-page')) return;

  var revealEls = root.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }, 1500);
  } else {
    revealEls.forEach(function (el) { el.classList.add('in-view'); });
  }

  root.querySelectorAll('.faq-item').forEach(function (item) {
    var btn = item.querySelector('.faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('open');
      var isOpen = !wasOpen;
      item.classList.toggle('open', isOpen);
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      var chev = btn.querySelector('.chev');
      if (chev) chev.textContent = isOpen ? '\u00d7' : '+';
    });
  });
})();
